import { useTranslation } from "../../../localization/useTranslation.ts";
import { DotLegalDialog, DotLegalHeader, DotLegalSelect } from "@dotlegal/dotlegal-ui-components";
import { useLegalEntityAuditClassificationReportDialog } from "./LegalEntityAuditClassificationReportDialog.hooks.ts";
import { LegalEntityScope } from "../../legalEntities/LegalEntities.types.ts";
import Box from "@mui/material/Box";

export interface ILegalEntityAuditClassificationReportDialogProps {
    type: "audit" | "classification";
    onClose: () => void;
    scope: LegalEntityScope;
}

function LegalEntityAuditClassificationReportDialog(props: ILegalEntityAuditClassificationReportDialogProps) {
    const { translateString } = useTranslation();
    const { options, setSelectedItem, openReport, selectedItem } = useLegalEntityAuditClassificationReportDialog(props);

    const header = props.type === "classification" ? translateString("legalEntityRiskClassificationReport") : translateString("legalEntityRiskAuditReport");
    const selectLabel = props.type === "classification" ? translateString("classification") : translateString("audit");
    const infoText =
        props.type === "classification"
            ? translateString("legalEntityRiskClassificationReportDialogText")
            : translateString("legalEntityRiskAuditReportDialogText");

    return (
        <DotLegalDialog
            size={"sm"}
            onDialogClose={props.onClose}
            buttonOkText={translateString("openReport")}
            open
            header={header}
            onOkClick={() => {
                openReport();
            }}
        >
            <Box
                sx={(theme) => ({
                    color: theme.palette.primary.dark,
                    fontSize: theme.typography.fontSize,
                    textAlign: "center",
                })}
            >
                {infoText}
            </Box>
            <DotLegalSelect
                options={options}
                selectedItem={selectedItem}
                onChange={(item) => setSelectedItem(item)}
                label={selectLabel}
                noOptionsLabel={translateString("noOptions")}
            />
        </DotLegalDialog>
    );
}

export default LegalEntityAuditClassificationReportDialog;
